import { lazy } from "react";

export const CUSTOMIZER_COMPONENTS = {
  predefineColarSoccer: lazy(() =>
    import("../components/Predefine_Colar_Soccer/Predefine_Colar_Soccer")
  ),
  crewNeckSoccerHalfDesign1: lazy(() =>
    import(
      "../components/Crew_Neck_Soccer_HalfDesign1/Crew_Neck_Soccer_HalfDesign1"
    )
  ),
  predefineColarFullSoccer: lazy(() =>
    import("../components/Predefine_ColarFull_Soccer/Predefine_ColarFull_Soccer")
  ),
  predefine2ColarSoccer: lazy(() =>
    import("../components/Predefine_2_Colar_Soccer/Predefine_2_Colar_Soccer")
  ),
  predefinePoloNackSoccer: lazy(() =>
    import("../components/Predefine_PoloNack_Soccer/Predefine_PoloNack_Soccer")
  ),
  predefinePoloNackFullSoccer: lazy(() =>
    import(
      "../components/Predefine_PoloNackFull_Soccer/Predefine_PoloNackFull_Soccer"
    )
  ),
  predefineVnackSoccer: lazy(() =>
    import("../components/Predefine_Vnack_Soccer/Predefine_Vnack_Soccer")
  ),
  predefineVnackFullSoccer: lazy(() =>
    import("../components/Predefine_VnackFull_Soccer/Predefine_VnackFull_Soccer")
  ),
  predefine2ColarFullSoccer: lazy(() =>
    import(
      "../components/Predefine_2_ColarFull_Soccer/Predefine_2_ColarFull_Socce"
    )
  ),
  predefine2PoloNackSoccer: lazy(() =>
    import(
      "../components/Predefine_2_PoloNack_Soccer/Predefine_2_PoloNack_Soccer"
    )
  ),
  predefine2PoloNackFullSoccer: lazy(() =>
    import(
      "../components/Predefine_2_PoloNackFull_Soccer/Predefine_2_PoloNackFull_Soccer"
    )
  ),
  predefine2VnackSoccer: lazy(() =>
    import("../components/Predefine_2_Vnack_Soccer/Predefine_2_Vnack_Soccer")
  ),
  predefine2VnackFullSoccer: lazy(() =>
    import(
      "../components/Predefine_2_VnackFull_Soccer/Predefine_2_VnackFull_Soccer"
    )
  ),
  predefineColarCricket: lazy(() =>
    import("../components/Predefine_Colar_Cricket/Predefine_Colar_Cricket")
  ),
  predefine2Cricket: lazy(() =>
    import("../components/Predefine_2_Cricket/Predefine_2_Cricket")
  ),
  predefine3Cricket: lazy(() =>
    import("../components/Predefine_3_Cricket/Predefine_3_Cricket")
  ),
  predefinePoloHalfCricket: lazy(() =>
    import("../components/Predefine_Polo_HalfS_Cricket/Predefine_Polo_HalfS_Cricket")
  ),
  predefine2PoloHalfCricket: lazy(() =>
    import(
      "../components/Predefine_2_Polo_HalfS_Cricket/Predefine_2_Polo_HalfS_Cricket"
    )
  ),
  predefine2CrewNeckCricket: lazy(() =>
    import(
      "../components/Predefine_2_CrewNeck_Cricket/Predefine_2_CrewNeck_Cricket"
    )
  ),
  predefine2VNeckCricket: lazy(() =>
    import("../components/Predefine_2_VNeck_Cricket/Predefine_2_VNeck_Cricket")
  ),
  predefine2VNeckFullCricket: lazy(() =>
    import(
      "../components/Predefine_2_VNeck_FullS_Cricket/Predefine_2_VNeck_FullS_Cricket"
    )
  ),
  predefine2PoloFullCricket: lazy(() =>
    import(
      "../components/Predefine_2_Polo_FullS_Cricket/Predefine_2_Polo_FullS_Cricket"
    )
  ),
  predefine3CrewNeckCricket: lazy(() =>
    import(
      "../components/Predefine_3_CrewNeck_Cricket/Predefine_3_CrewNeck_Cricket"
    )
  ),
  predefine3VNeckCricket: lazy(() =>
    import("../components/Predefine_3_VNeck_Cricket/Predefine_3_VNeck_Cricket")
  ),
  predefine3VNeckFullCricket: lazy(() =>
    import(
      "../components/Predefine_3_VNeck_FullS_Cricket/Predefine_3_VNeck_FullS_Cricket"
    )
  ),
  predefineColarBasketball: lazy(() =>
    import("../components/Predefine_Colar_Basketball/Predefine_Colar_Basketball")
  ),
  predefine2Basketball: lazy(() =>
    import("../components/Predefine_2_Basketball/Predefine_2_Basketball")
  ),
  predefine3Basketball: lazy(() =>
    import("../components/Predefine_3_Basketball/Predefine_3_Basketball")
  ),
  predefine2ColarGoalkeeper: lazy(() =>
    import(
      "../components/Predefine_2_Colar_Goalkeeper/Predefine_2_Colar_Goalkeeper"
    )
  ),
  predefineColarGoalkeeper: lazy(() =>
    import("../components/Predefine_Colar_Goalkeeper/Predefine_Colar_Goalkeeper")
  ),
  predefineGoalkeeperCrewNeckHalfD1: lazy(() =>
    import(
      "../components/Predefine_Goalkeeper_CrewNeckHalf_D1/Predefine_Goalkeeper_CrewNeckHalf_D1"
    )
  ),
  predefineGoalkeeperVNeckHalfD1: lazy(() =>
    import(
      "../components/Predefine_Goalkeeper_VNeckHalf_D1/Predefine_Goalkeeper_VNeckHalf_D1"
    )
  ),
  SoccerKitConfigurator3: lazy(() =>
    import(
      "../components/SoccerKitConfigurator3/SoccerKitConfigurator3"
    )
  ),
  Vneckconfigurator3: lazy(() =>
    import(
      "../components/SoccerKitConfigurator3/Vneckconfigurator3"
    )
  ),
  predefine3Goalkeeper: lazy(() =>
    import(
      "../components/Predefine_3_Goalkeeper/Predefine_3_Goalkeeper"
    )
  ),
  predefineGoalkeeperVNeckfull: lazy(() =>
    import(
      "../components/Predefine_Vneckfull_goalkeeper/Vneckfullsleevesgoalkeeperconfigurator"
    )
  ),
  predefineGoalkeeperPoloHalfD1: lazy(() =>
    import(
      "../components/Predefine_Goalkeeper_Polo_D1/Predefine_Goalkeeper_PoloHalf_D1"
    )
  ),
  predefineGoalkeeperPoloFullD1: lazy(() =>
    import(
      "../components/Predefine_Goalkeeper_Polo_D1/Predefine_Goalkeeper_PoloFull_D1"
    )
  ),
  Predefine2ColarHalfGoalkeeper: lazy(() =>
    import(
      "../components/Predefine_2_Colar_Goalkeeper/Predefine_2_ColarHalf_Goalkeeper"
    )
  ),
  Predefine2PoloFullGoalkeeper: lazy(() =>
    import(
      "../components/Predefine_2_Colar_Goalkeeper/Predefine_2_PoloFull_Goalkeeper"
    )
  ),
  Predefine2PoloHalfGoalkeeper: lazy(() =>
    import(
      "../components/Predefine_2_Colar_Goalkeeper/Predefine_2_PoloHalf_Goalkeeper"
    )
  ),
  Predefine2VneckHalfGoalkeeper: lazy(() =>
    import(
      "../components/Predefine_2_Colar_Goalkeeper/Predefine_2_VneckHalf_Goalkeeper"
    )
  ),
  predefine2GoalkeeperVNeckfull: lazy(() =>
    import(
      "../components/Predefine_2_Colar_Goalkeeper/Predefine_2_VneckFull_Goalkeeper"
    )
  ),
  predefine3CrewHalfGoalkeeper: lazy(() =>
    import(
      "../components/Predefine_3_Goalkeeper/Predefine_3_CrewHalf_Goalkeeper"
    )
  ),
  predefine3VNeckHalfGoalkeeper: lazy(() =>
    import(
      "../components/Predefine_3_Goalkeeper/Predefine_3_VneckHalf_Goalkeeper"
    )
  ),
  predefine3VNeckFullGoalkeeper: lazy(() =>
    import(
      "../components/Predefine_3_Goalkeeper/Predefine_3_VneckFull_Goalkeeper"
    )
  ),
  predefine3PoloFullGoalkeeper: lazy(() =>
    import(
      "../components/Predefine_3_Goalkeeper/Predefine_3_PoloFull_Goalkeeper"
    )
  ),
  predefine3PoloHalfGoalkeeper: lazy(() =>
    import(
      "../components/Predefine_3_Goalkeeper/Predefine_3_PoloHalf_Goalkeeper"
    )
  ),
  
  SoccerVNeckFullConfigurator3: lazy(() =>
    import(
      "../components/SoccerKitConfigurator3/SoccerVneckFullconfigurator3"
    )
  ),
  SoccerPoloHalfConfigurator3: lazy(() =>
    import(
      "../components/SoccerKitConfigurator3/SoccerPoloHalfconfigurator3"
    )
  ),
  SoccerPoloFullConfigurator3: lazy(() =>
    import(
      "../components/SoccerKitConfigurator3/SoccerPoloFullconfigurator3"
    )
  ),
  SoccerKitFullConfigurator3: lazy(() =>
    import(
      "../components/SoccerKitConfigurator3/SoccerKitFullConfigurator3"
    )
  ),
  predefine3PoloFullsCricket: lazy(() =>
    import(
      "../components/Predefine_3_Polo_FullS_Cricket/Predefine_3_Polo_FullS_Cricket"
    )
  ),
  PredefineColarHalfCricketd1: lazy(() =>
    import(
      "../components/Predefine_Colar_Cricket/Predefine_ColarHalf_Cricket_d1"
    )
  ),
  PredefineVneckFullCricketd1: lazy(() =>
    import(
      "../components/Predefine_Colar_Cricket/Predefine_VneckFull_Cricket_d1"
    )
  ),
  PredefineVneckHalfCricketd1: lazy(() =>
    import(
      "../components/Predefine_Colar_Cricket/Predefine_VneckHalf_Cricket_d1"
    )
  ),
  predefinePoloHalfCricketd1: lazy(() =>
    import(
      "../components/Predefine_Colar_Cricket/Predefine_PoloHalf_Cricket_d1"
    )
  ),
  predefinePoloFullCricketd1: lazy(() =>
    import(
      "../components/Predefine_Colar_Cricket/Predefine_PoloFull_Cricket_d1"
    )
  ),
};

export const CUSTOMIZER_ROUTES = [
  //soccer design 1
  { path: "/Predefine_Colar_Soccer", componentKey: "predefineColarSoccer" },
  { path: "/colar", componentKey: "predefineColarSoccer" },
  { path: "/crewn", componentKey: "crewNeckSoccerHalfDesign1" },
  { path: "/colar-full", componentKey: "predefineColarFullSoccer" },
 
  { path: "/polo", componentKey: "predefinePoloNackSoccer" },
  { path: "/polo-full", componentKey: "predefinePoloNackFullSoccer" },
  { path: "/vnack", componentKey: "predefineVnackSoccer" },
  { path: "/vnack-full", componentKey: "predefineVnackFullSoccer" },

 
 //cricket design 1
  { path: "/cricket", componentKey: "predefineColarCricket" },
  {
    path: "/cricket-crew-half", componentKey: "PredefineColarHalfCricketd1"

  },
  {
    path:"/cricket-vneck-full", componentKey: "PredefineVneckFullCricketd1"
  },
  {
    path:"/cricket-vneck-half", componentKey: "PredefineVneckHalfCricketd1"
  },
  {
    path:"/cricket-polo-half", componentKey: "predefinePoloHalfCricketd1"
  },
  {
    path:"/cricket-polo-full", componentKey: "predefinePoloFullCricketd1"
  },
 //cricket design 2
{ path: "/cricket-2", componentKey: "predefine2Cricket" },
 { path: "/cricket-2-polo-halfs", componentKey: "predefinePoloHalfCricket" },
{ path: "/cricket-2-crewn-half", componentKey: "predefine2CrewNeckCricket" },
 { path: "/cricket-2-vneck", componentKey: "predefine2VNeckCricket" },
 { path: "/cricket-2-vneck-fulls", componentKey: "predefine2VNeckFullCricket" },
 { path: "/cricket-2-polo-fulls", componentKey: "predefine2PoloFullCricket" },
 //cricket design 3
 { path: "/cricket-3", componentKey: "predefine3Cricket" },
 { path: "/cricket-3-crewn", componentKey: "predefine3CrewNeckCricket" },
 { path: "/cricket-3-VNeck", componentKey: "predefine3VNeckCricket" },
 { path: "/cricket-3-polo-halfs", componentKey: "predefine2PoloHalfCricket" },
  { path: "/cricket-3-vneck-fulls", componentKey: "predefine3VNeckFullCricket" },
 {
  path: "/cricket-3-polo-fulls", componentKey: "predefine3PoloFullsCricket"
 },
  //basketball
  { path: "/basket", componentKey: "predefineColarBasketball" },
  { path: "/basket-2", componentKey: "predefine2Basketball" },
  { path: "/basket-3", componentKey: "predefine3Basketball" },
  { path: "/goalkeeper-2", componentKey: "predefine2ColarGoalkeeper" },
  { path: "/goalkeeper", componentKey: "predefineColarGoalkeeper" },
  //soccer 3
  {path: "/soccer-3", componentKey: "SoccerKitConfigurator3"},
  {path: "/soccer-3-vneck-half", componentKey: "Vneckconfigurator3"},
  {
    path:"/soccer-3-vneck-full", componentKey: "SoccerVNeckFullConfigurator3"
  },
  {
    path:"/soccer-3-polo-half", componentKey: "SoccerPoloHalfConfigurator3"
  },
  {
    path:"/soccer-3-polo-full", componentKey: "SoccerPoloFullConfigurator3"
  },
  {
    path:"/soccer-3-colar-full", componentKey: "SoccerKitFullConfigurator3"
  },


  {
    path:"/goalkeeper-3" , componentKey: "predefine3Goalkeeper"
  },
  {
    path: "/goalkeeper-crewn-half",
    componentKey: "predefineGoalkeeperCrewNeckHalfD1",
  },
  {
    path:"/goalkeeper-vneck-full", componentKey: "predefineGoalkeeperVNeckfull"
  },
  {
    path: "/goalkeeper-vneck-half",
    componentKey: "predefineGoalkeeperVNeckHalfD1",
  },
  {
    path:"/goalkeeper-polo-half",
    componentKey: "predefineGoalkeeperPoloHalfD1"
  },
  {
    path:"/goalkeeper-polo-full",
    componentKey: "predefineGoalkeeperPoloFullD1"
  },
  //goalkeeper design2 
  {
    path:"/goalkeeper-2-crew-half", componentKey:"Predefine2ColarHalfGoalkeeper"
  },
  {
    path:"/goalkeeper-2-polofull", componentKey:"Predefine2PoloFullGoalkeeper"
  },
  {
    path:"/goalkeeper-2-polo-half", componentKey:"Predefine2PoloHalfGoalkeeper"
  },
  {
    path:"/goalkeeper-2-vneck-half", componentKey:"Predefine2VneckHalfGoalkeeper"
  },
  {
    path:"/goalkeeper-2-vneck-full", componentKey:"predefine2GoalkeeperVNeckfull"

  },

  //goalkeeper design 3
  {
    path: "/goalkeeper-3-crew-half",
    componentKey: "predefine3CrewHalfGoalkeeper"
  },
  {
    path: "/goalkeeper-3-vneck-half",
    componentKey: "predefine3VNeckHalfGoalkeeper"
  },
  {
    path: "/goalkeeper-3-vneck-full",
    componentKey: "predefine3VNeckFullGoalkeeper"
  },
  {
    path:"/goalkeeper-3-polo-full", componentKey: "predefine3PoloFullGoalkeeper"
  },
  {
    path:"/goalkeeper-3-polo-half", componentKey: "predefine3PoloHalfGoalkeeper"
  },
  //soccer 2 vneck + polo

   { path: "/colar-2", componentKey: "predefine2ColarSoccer" },
    { path: "/vnack-2", componentKey: "predefine2VnackSoccer" },
    { path: "/colar-2-full", componentKey: "predefine2ColarFullSoccer" },
     { path: "/vnack-2-full", componentKey: "predefine2VnackFullSoccer" },
     { path: "/polo-2", componentKey: "predefine2PoloNackSoccer" },
  { path: "/polo-2-full", componentKey: "predefine2PoloNackFullSoccer" },
  

];
